<template>
  <div id="CourseTree" v-loading="loading" class>
    <div class="class-container">
      <div class="class-content">教学视频数：{{classNumList.videoCount || 0}}</div>
      <div class="class-content">课程试题数：{{classNumList.questionCount || 0}}</div>
      <div class="class-content">练习套数：{{classNumList.practiceCount || 0 }}</div>
      <div class="class-content">章节测验：{{classNumList.chapterCount || 0}}</div>
      <div class="class-content">综合测验：{{classNumList.comprehensiveCount || 0 }}</div>
    </div>
    <el-row style="margin: 10px 20px">
      <el-col>
        <el-button v-if="userType !== '53'" type="primary" size="mini" @click="addRoot">添加根目录</el-button>
        <el-button
          v-if="userType !== '53'"
          type="primary"
          size="mini"
          @click="insertCourseTree"
        >导入课件架构</el-button>
        <el-button
          v-if="userType !== '53'"
          type="primary"
          size="mini"
          @click="exportCourseTree"
        >导出课件架构</el-button>
        <el-button
          v-if="userType !== '53'"
          type="primary"
          size="mini"
          @click="exportExamsQuest"
        >导出课程试题</el-button>
        <el-button
          v-if="userType !== '53'"
          type="primary"
          size="mini"
          @click="importExamsQuest"
        >更新试题知识点</el-button>
        <el-button type="primary" size="mini" v-if="false">复制课程</el-button>
        <el-button
          v-if="userType === '3' || userType === '52' || userType === '53'"
          @click="previewFront"
          type="primary"
          size="mini"
        >前台预览</el-button>
      </el-col>
    </el-row>

    <el-tree
      :data="data"
      node-key="id"
      :expand-on-click-node="false"
      :default-expanded-keys="expandedList"
      @node-expand="nodeExpand"
      @node-collapse="nodeCollapse"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <span
            v-show="node.level === 3"
            style="
              display: inline-block;
              padding: 2px 3px;
              background: #409eff;
              color: #fff;
            "
          >{{ node.data.type }}</span>
          {{ node.label }}
        </span>
        <div v-if="userType !== '53'">
          <span>
            <i
              class="el-icon-bottom"
              @click="sort(2, node)"
              v-show="node.nextSibling != null || node.nextSibling != undefined"
            ></i>
            <i
              class="el-icon-top"
              @click="sort(1, node)"
              v-show="
                node.previousSibling != null ||
                node.previousSibling != undefined
              "
            ></i>
          </span>
          <div style="display: inline-block; width: 300px; text-align: right">
            <span v-show="node.level === 1">
              <el-button type="text" size="mini" @click="addChapter(data)">添加章节</el-button>
              <el-button type="text" size="mini" @click="editChapter(data)">编辑</el-button>
              <el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
            </span>
            <span v-show="node.level === 2">
              <el-button type="text" size="mini" @click="addPeriod(data, node)">添加课时</el-button>
              <el-button type="text" size="mini" @click="editPeriod(data, node)">编辑</el-button>
              <el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
            </span>
            <span v-show="node.level === 3">
              <span
                v-if="node.data.videoDataType == '1'"
                style="
                  display: inline-block;
                  padding: 2px 3px;
                  background: #409eff;
                  color: #fff;
                  margin-right: 5px;
                  font-size: 12px;
                "
              >视频</span>
              <span
                v-if="node.data.videoDataType == '2'"
                style="
                  display: inline-block;
                  padding: 2px 3px;
                  background: #409eff;
                  color: #fff;
                  margin-right: 5px;
                  font-size: 12px;
                "
              >音频</span>
              <span
                v-if="node.data.videoDataType == '3'"
                style="
                  display: inline-block;
                  padding: 2px 3px;
                  background: #409eff;
                  color: #fff;
                  margin-right: 5px;
                  font-size: 12px;
                "
              >文本</span>
              <span
                v-if="node.data.videoDataType == '4'"
                style="
                  display: inline-block;
                  padding: 2px 3px;
                  background: #409eff;
                  color: #fff;
                  margin-right: 5px;
                  font-size: 12px;
                "
              >文档</span>
              <span
                v-if="node.data.videoDataType == '5'"
                style="
                  display: inline-block;
                  padding: 2px 3px;
                  background: #409eff;
                  color: #fff;
                  margin-right: 5px;
                  font-size: 12px;
                "
              >音视频链接</span>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '练'"
                @click="() => editCourse(data, node, 2)"
              >关联练习</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '测'"
                @click="() => editCourse(data, node, 3)"
              >关联测验</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '考'"
                @click="() => editCourse(data, node, 6)"
              >关联试卷</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '课'"
                @click="() => editCourse(data, node, 1)"
              >编辑</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.videoDataType == '1'"
                @click="addVideo(data)"
              >视频弹题</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '面'"
                @click="() => editCourse(data, node, 4)"
              >编辑</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="node.data.type == '直'"
                @click="() => editCourse(data, node, 5)"
              >编辑</el-button>
              <el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
            </span>
          </div>
        </div>
      </span>
    </el-tree>

    <Course-add-root
      v-show="ifRoots"
      ref="CourseAddRoot"
      @getRootName="getRootName"
      :userType="userType"
    ></Course-add-root>
    <Course-add-chapter
      v-show="ifChapter"
      ref="CourseAddChapter"
      @getChapterName="getChapterName"
      @editChapterName="editChapterName"
      :userType="userType"
    ></Course-add-chapter>
    <Course-add-period
      v-if="ifPeriod"
      ref="CourseAddPeriod"
      @getLinkCourse="getLinkCourse"
      @getPeriodName="getPeriodName"
      @getPeriodType="getPeriodType"
      @editPeriodName="editPeriodName"
      @closeDialog="closeDialog"
      @endSave="getList"
      :userType="userType"
      :mhmId="mhmId"
      :courseWareId="courseWareId"
      :zyVideoId="courseId"
    ></Course-add-period>
    <Course-video-player
      v-if="ifVideo"
      ref="CourseVideoPlayer"
      @closeCourseVideoPlayer="closeCourseVideoPlayer"
    ></Course-video-player>
    <Course-edit-course
      v-show="ifEdit"
      ref="CourseEditCourse"
      @sendChooseId="sendChooseIds"
      @sendName="sendName"
      @sendKnows="sendKnows"
      :userType="userType"
    ></Course-edit-course>
    <Course-location-files v-show="ifLocation" ref="CourseLocationFiles"></Course-location-files>
    <Course-choose-course v-show="ifChoose" ref="CourseChooseCourse"></Course-choose-course>
    <Course-test v-show="ifTest" ref="CourseTest"></Course-test>
    <CourseTreeInsert
      v-if="CourseTreeInsertDialog"
      ref="CourseTreeInsertDialog"
      :userType="userType"
      @closeCourseTreeInsertDialog="closeCourseTreeInsertDialog"
    ></CourseTreeInsert>
    <CourseExamsQuestInsert
      v-if="CourseExamsQuestInsertDialog"
      ref="CourseExamsQuestInsertDialog"
      :userType="userType"
      @closeCourseExamsQuestInsertDialog="closeCourseExamsQuestInsertDialog"
    ></CourseExamsQuestInsert>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import CourseAddRoot from './Course-addRoot'
import CourseAddChapter from './Course-addChapter'
import CourseAddPeriod from './Course-addPeriod'
import CourseVideoPlayer from './Course-videoPlayer'
import CourseEditCourse from './Course-editCourse'
import CourseLocationFiles from './Course-locationFiles'
import CourseChooseCourse from './Course-chooseCourse'
import CourseTest from './Course-chooseTest'
import CourseTreeInsert from './Course-tree-insert'
import CourseExamsQuestInsert from './Course-examsQuest-insert'
import * as api from '@/api/courseStructure/courseStructure'

export default {
  name: 'CourseTree',
  components: {
    CourseAddRoot,
    CourseAddChapter,
    CourseAddPeriod,
    CourseVideoPlayer,
    CourseEditCourse,
    CourseLocationFiles,
    CourseChooseCourse,
    CourseTest,
    CourseTreeInsert,
    CourseExamsQuestInsert,
  },
  //父页面传入课程id
  props: ['courseId', 'type', 'courseName', 'userType', 'mhmId'],
  inject: ['reload'],

  data() {
    return {
      editKnows: '',
      editName: '',
      sendChooseId: '',
      listData: [],
      loading: false,
      data: [],
      expandedList: [],
      ifRoots: false,
      ifChapter: false,
      ifPeriod: false,
      ifVideo: false,
      ifEdit: false,
      ifChoose: false,
      ifTest: false,
      ifLocation: false,
      CourseTreeInsertDialog: false,
      CourseExamsQuestInsertDialog: false,
      rootName: '',
      chapterName: '',
      point: '',
      name: '',
      types: '',
      // courseId:'',
      editChapterId: '',
      editPeriodId: '',
      parentPeriodId: '',
      kjType: '',
      addPeriodId: '',
      courseWareId: '', //课件库id
      structureId: '', //课程架构id
      linkCourseId: '', //关联课程id
      courseWareIdForExamQuest: '', //给导入导出试题用的课件id
      timesOfOpen: 1,
      classNumList:'', // 课程架构数
    }
  },
  methods: {
    // 上下移
    sort(type, node) {
      //type：1上移  2 下移
      let id1 = node.data.id,
        id2 = ''
      if (type == '1') {
        //上移
        id2 = node.previousSibling.data.id
        // api.updateSort(node.data.id,node.previousSibling.data.id).then((data)=>{
        //   data = data.data
        //   if(data.code == 100000){
        //     this.$message({ type: 'success', message: data.msg })
        //     this.reload()
        //   }else {
        //     this.$message({ type: 'error', message: data.msg })
        //   }
        //
        // })
      } else {
        //下移
        id2 = node.nextSibling.data.id
      }
      api.updateSort(id1, id2).then((data) => {
        data = data.data
        if (data.code == 100000) {
          this.getList()
          this.$message({ type: 'success', message: data.msg })
          // this.reload()
        } else {
          this.$message({ type: 'error', message: data.msg })
        }
      })
    },
    // 获取课程架构数量
    getClassNum(){
       let params = {
        courseId:this.courseId,
        courseWareId:this.courseWareIdForExamQuest,
      }
      api.getResourceTotal(params).then((data) => {
        data = data.data
        if (data.code == 100000) {
          this.classNumList = data.data
        } else {
          this.$message({ type: 'error', message: data.msg })
        }
      })
    },
    // 节点展开时回调
    nodeExpand(data) {
      this.expandedList.push(data.id) // 在节点展开是添加到默认展开数组
    },
    //节点关闭时回调
    nodeCollapse(data) {
      this.expandedList.splice(this.expandedList.indexOf(data.id), 1) // 收起时删除数组里对应选项
    },
    // 获取数据  课时类型(0-课件1-练习2-考试)
    getList() {
      if (this.timesOfOpen > 1) {
        this.$emit('updateCheckCourseware')
      }
      this.timesOfOpen++
      this.data = []
      // this.loading = true
      let reqdata = {
        courseId: this.courseId,
      }
      api.getList(reqdata).then((res) => {
        this.listData = res.data.data
        this.courseWareIdForExamQuest = this.listData[0].courseWareId
        // 获取课程架构数
        this.getClassNum()
        this.listData.forEach((item) => {
          this.data.push({
            id: item.id,
            label: item.label,
            children: item.children,
          })
        })
      })
    },

    append(data) {
      const newChild = {
        id: 0,
        label: this.name,
        children: [],
        type: this.types,
      }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
    },

    remove(node, data) {
      const formData = {
        zyVideoSectionId: data.id,
      }
      api.deleteCourseStructure(formData).then((result) => {
        if (result.data.data == true) {
          const parent = node.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex((d) => d.id === data.id)
          children.splice(index, 1)
          this.$emit('updateCheckCourseware')
          this.$message({ type: 'success', message: '删除成功' })
        } else {
          this.$message({ type: 'error', message: '存在子节点，不允许删除' })
        }
      })
    },

    // 增加跟节点
    addRoot(data) {
      this.$nextTick(() => {
        this.$refs.CourseAddRoot.init()
      })
    },
    async getRootName(msg) {
      const formData = {
        title: msg,
        vid: this.courseId,
      }
      //调用保存方法
      const result = await api.addCourseStructure(formData).then((res) => res)
      if(result.data.code == 100000){
        if (result.data.data === -1 || result.data.data === null) {
          return this.$message.error('添加失败,根目录重复')
        }
        let CourseStructureId = result.data.data
        this.rootName = msg
        const newChild = {
          id: CourseStructureId,
          label: this.rootName,
          children: [],
        }
        if (!this.data) {
          this.$set(this.data, 'children', [])
        }
        this.data.push(newChild)
        this.$message({ type: 'success', message: '添加根目录成功' })
      }else{
         return this.$message.error('添加失败')
      }
      
    },

    // 增加章节
    addChapter(data) {
      this.point = data
      this.$nextTick(() => {
        this.$refs.CourseAddChapter.init(1, '')
      })
    },
    async getChapterName(msg) {
      this.name = msg
      const formData = {
        title: msg,
        vid: this.courseId,
        pid: this.point.id, //父id
      }
      //调用保存方法
      const result = await api.addCourseStructure(formData).then((res) => res)
      if(result.data.code == 100000){
          if (result.data.data === -1) {
            return this.$message.error('添加失败,章节重复')
          }
          let CourseStructureId = result.data.data
          this.append(this.point)
          this.$message({ type: 'success', message: '添加章节成功' })
          this.reload() //刷新
          this.$router.push({
            name: 'CourseContentManager', //tab所在的页面
            query: {
              id: this.courseId,
              type: this.type,
              tabs: 'second',
            },
          })
      }else{
         return this.$message.error('添加失败')
      }
    },
    // 编辑章节
    editChapter(data) {
      this.point = data
      this.editChapterId = this.point.id
      this.$nextTick(() => {
        this.$refs.CourseAddChapter.init(2, this.point.label)
      })
    },
    async editChapterName(msg) {
      this.name = msg
      const formData = {
        title: msg,
        vid: this.courseId,
        // parentId:this.point.id, //父id
        zyVideoSectionId: this.editChapterId,
      }
      //调用保存方法
      const result = await api.addCourseStructure(formData).then((res) => res)
      this.$message({ type: 'success', message: '编辑章节成功' })
      this.reload() //刷新
      this.$router.push({
        name: 'CourseContentManager', //tab所在的页面
        query: {
          id: this.courseId,
          type: this.type,
          tabs: 'second',
        },
      })
    },

    // 增加课时
    addPeriod(data, node) {
      this.addPeriodId = node.data.id
      this.point = data
      let test = 1 //1为可选择考试  2为不可选
      if (data.children.length == 0) {
        test = 1
      } else {
        for (let i = 0; i < data.children.length; i++) {
          if (data.children[i].type != '考') {
            test = 2
          } else {
            test = 3
          }
        }
      }
      this.ifPeriod = true
      this.$nextTick(() => {
        this.$refs.CourseAddPeriod.init(1, '', test, data.courseWareId)
      })
    },
    getPeriodType(msg) {
      this.kjType = msg
      if (msg == '0') {
        msg = '课件'
      } else if (msg == '1') {
        msg = '练习'
      } else if (msg == '2') {
        msg = '测验'
      } else if (msg == '3') {
        msg = '面授'
      } else if (msg == '4') {
        msg = '直播'
      } else if (msg == '5') {
        msg = '考试'
      }
      this.types = msg.substr(0, 1)
      this.append(this.point)
    },
    getLinkCourse(data) {
      this.linkCourseId = data
    },
    async getPeriodName(msg) {
      // debugger
      this.name = msg.name
      const formData = {
        title: this.name,
        vid: this.courseId,
        // parentId:this.point.id, //父id
        pid: this.addPeriodId, //父id
        contentType: this.kjType,
        linkCourseId: this.linkCourseId,
      }
      //调用保存方法
      const result = await api.addCourseStructure(formData).then((res) => res)
      let CourseStructureId = result.data.data

      // this.append(this.point)
      this.point.id = CourseStructureId
      if (this.linkCourseId !== '' && result.data.code === 100000) {
        this.linkCourseId = ''
        this.$refs.CourseAddPeriod.endSave()
        this.$message.success('操作成功')
      } else if (this.linkCourseId === '') {
        this.$refs.CourseAddPeriod.appendChild(CourseStructureId)
      }
      // this.$message({ type: 'success', message: '添加课时成功' })
      // this.reload() //刷新
      // this.$router.push({
      //   name: 'CourseContentManager', //tab所在的页面
      //   query: {
      //     id: this.courseId,
      //     type: this.type,
      //     tabs: 'second',
      //   },
      // })
    },
    closeDialog() {
      this.ifPeriod = false
    },
    // 增加课时----end

    // 编辑课时
    editPeriod(data, e) {
      this.parentPeriodId = e.parent.key
      this.point = data
      this.editPeriodId = this.point.id
      this.ifPeriod = true
      this.$nextTick(() => {
        this.$refs.CourseAddPeriod.init(
          2,
          this.point.label,
          this.linkCourseId,
          this.kjType
        )
      })
    },

    async editPeriodName(msg) {
      this.name = msg
      const formData = {
        title: msg.name,
        vid: this.courseId,
        pid: this.parentPeriodId, //父id
        zyVideoSectionId: this.editPeriodId,
        linkCourseId: this.linkCourseId,
      }
      //调用保存方法
      const result = await api.addCourseStructure(formData).then((res) => res)
      if (this.kjType === '') {
        if (result.data.code === 100000) {
          this.$message({ type: 'success', message: '编辑课时成功' })
        } else {
          this.$message.error(result.data.msg)
        }
        this.kjType = ''
      }
      if (this.linkCourseId !== '') {
        if (result.data.code === 100000) {
          this.$message.success(result.data.msg)
        } else {
          this.$message.error(result.data.msg)
        }
        this.linkCourseId = ''
      }
      this.getList()

      // this.reload() //刷新
      // this.$router.push({
      //   name: 'CourseContentManager', //tab所在的页面
      //   query: {
      //     id: this.courseId,
      //     type: this.type,
      //     tabs: 'second',
      //   },
      // })
    },

    // 编辑课时---end

    // 视频弹题
    addVideo(data) {
      this.ifVideo = true
      this.$nextTick(() => {
        this.$refs.CourseVideoPlayer.init(
          data.courseWareId,
          data.duration,
          data.id,
          data.qid
        )
      })
    },
    //关闭视频弹题
    closeCourseVideoPlayer() {
      this.ifVideo = false
      this.reload() //刷新
    },
    // 编辑课件
    editCourse(data, e, formType) {
      // let ifEditTypes
      // let videoDataId = data.videoDataId //查询当前详情id
      // let videoDataType = data.videoDataType //是否存在课件  有值即为存在
      // if (
      //   videoDataType == '' ||
      //   videoDataType == null ||
      //   videoDataType == undefined
      // ) {
      //   ifEditTypes = 1 //新增
      // } else {
      //   ifEditTypes = 2 //编辑
      // }
      // this.courseWareId = data.courseWareId
      // this.structureId = data.id
      // this.$nextTick(() => {
      //   this.$refs.CourseEditCourse.init(
      //     data.id,
      //     this.courseId,
      //     data.label,
      //     data.courseWareId,
      //     ifEditTypes,
      //     videoDataId
      //   )
      //   // this.$refs.CourseChooseCourse.init()
      // })
      this.parentPeriodId = e.parent.key
      this.point = data
      this.editPeriodId = this.point.id
      this.ifPeriod = true
      this.$nextTick(() => {
        this.$refs.CourseAddPeriod.init(
          '3',
          data.label,
          '1',
          data.courseWareId,
          data.videoDataId,
          data.videoDataType,
          data.id,
          formType
        )
      })
    },
    sendChooseIds(data) {
      this.sendChooseId = data
    },

    sendName(data) {
      this.editName = data
    },

    sendKnows(data) {
      this.editKnows = data
      this.$nextTick(() => {
        this.$refs.CourseChooseCourse.init(
          this.courseWareId,
          this.editName,
          this.editKnows,
          this.structureId,
          this.sendChooseId,
          this.mhmId
        )
      })
    },

    // //调用根目录保存接口
    // async saveCourseStructure(formData){
    //   const result=await api.addCourseStructure(formData).then(res =>res )
    //     return result.data.data;
    // },

    // 添加练习/测验
    addTest(data, testStatus) {
      this.$nextTick(() => {
        this.$refs.CourseTest.init(
          data.courseWareId,
          data.id,
          data.eid,
          testStatus
        )
      })
    },
    insertCourseTree() {
      this.CourseTreeInsertDialog = true
      this.$nextTick(() => {
        this.$refs.CourseTreeInsertDialog.init()
      })
    },
    closeCourseTreeInsertDialog() {
      this.CourseTreeInsertDialog = false
    },
    exportCourseTree() {
      window.open(
        `http://${window.location.host}/zkfz/elZyVideoSection/exportCourseList?courseId=${this.courseId}`
      )
      // window.open(
      //   `http://gz.hnjk.net/zkfz/elZyVideoSection/exportCourseList?courseId=${this.courseId}`
      // )
    },
    exportExamsQuest() {
      window.open(
        `http://${window.location.host}/zkfz/elZyVideoSection/exportExamsQuest?courseWareId=${this.courseWareIdForExamQuest}&courseName=${this.courseName}`
      )
    },
    importExamsQuest() {
      this.CourseExamsQuestInsertDialog = true
      this.$nextTick(() => {
        this.$refs.CourseExamsQuestInsertDialog.init()
      })
    },
    closeCourseExamsQuestInsertDialog() {
      this.CourseExamsQuestInsertDialog = false
    },
    previewFront() {
      window.open(`${this.url}/course/${this.courseId}.html?is_look=1`)
    },
  },
  created() {
    // this.getCourseId()
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: rgba(102, 204, 255, 0.445) !important;
}
/deep/.el-tree-node__content:hover {
  background-color: rgba(102, 204, 255, 0.445);
}
/deep/
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgba(102, 204, 255, 0.445);
}
</style>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.class-container {
  width: 700px;
  padding: 10px 30px 20px 20px;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  /* background-color: #ccc; */
}
.class-content {
  font-size: 14px;
}
</style>
